import { get, isEmpty, has } from 'lodash'

const GET_STAGES = 'stage.stages.data'

export const getters = {
  regulation: state => state.regulation,
  isCompleted: (state, getters, rootState) => {
    const stages = get(rootState, GET_STAGES)
    const hasData = !isEmpty(stages)

    if (!getters.hasRegulation || !hasData) {
      return false
    }
    const completeds = stages.filter(x => x.mnemonic === 'STG_COMPLETED').map(x => x.id)
    const isCompleted = completeds.includes(state.regulation.stageID)
    return isCompleted
  },
  hasRegulation: state => has(state, 'regulation.id')
}

const GET_REGULATION = 'regulation/regulation'

export const gettersTypes = {
  GET_REGULATION
}
export default getters



// WEBPACK FOOTER //
// ./src/store/module/regulation/getters.js